import { startAnalytics } from '@elc-online/up-analytics';

const profile = document.currentScript?.dataset.profile;
const pageData = window.ELCO.Analytics.pageData();
const runtime = window.ELCO.Env.runtime();

const site = JSON.parse(
  (document.currentScript?.dataset.site || '{}') as string,
);
const dataLayer = {
  ...pageData,
  site: site,
};

startAnalytics(
  {
    analytics: {
      env: /^(dev|prod)$/.test(runtime) ? runtime : 'qa',
      url: 'tags.tiqcdn.com',
      profile: profile,
    },
  },
  dataLayer,
);
